/*
 * Interface strings, Indonesian.
 *
 * The "ui" bucket: everything outside the calculators. Every language the
 * picker offers has a full file here, so no English leaks into a translated
 * interface. Calculator text lives in i18n/calc, which is English and Spanish
 * only. Legal and disclaimer text is in neither: it stays English everywhere,
 * with legal.englishGoverning beside it.
 *
 * Plural keys end _one/_other and are chosen by Intl.PluralRules for this
 * language; Chinese, Thai, Vietnamese and Indonesian have one form, so they
 * carry only _other and every count lands there.
 */

/* NOT REVIEWED BY A NATIVE SPEAKER. */

const strings = {
  "landing.lead": "Masuk dengan akun AquaNetica Anda untuk melanjutkan.",
  "landing.signIn": "Masuk",
  "landing.signUpFree": "Pendaftaran gratis.",
  "common.close": "Tutup",
  "common.cancel": "Batal",
  "profile.title": "Profil sistem · {name}",
  "profile.subtitle": "Gia memakai ini untuk menyesuaikan setiap jawaban di proyek ini. Kosongkan kolom yang tidak relevan.",
  "profile.species": "Spesies",
  "profile.speciesPlaceholder": "mis. salmon Atlantik",
  "profile.systemType": "Jenis sistem",
  "profile.select": "Pilih…",
  "profile.sys.ras": "RAS (resirkulasi)",
  "profile.sys.flow": "Air mengalir",
  "profile.sys.pond": "Tambak/kolam",
  "profile.sys.cage": "Keramba jaring apung",
  "profile.sys.hatchery": "Hatchery (panti benih)",
  "profile.sys.other": "Lainnya",
  "profile.volume": "Volume total (L)",
  "profile.temp": "Suhu target (°C)",
  "profile.lifeStage": "Tahap hidup",
  "profile.lifeStagePlaceholder": "benih, juvenil, induk",
  "profile.location": "Lokasi",
  "profile.locationPlaceholder": "mis. Lampung, ID",
  "profile.notes": "Catatan tambahan",
  "profile.notesPlaceholder": "Hal lain yang perlu Gia ketahui tentang sistem ini",
  "profile.save": "Simpan profil",
  "help.title": "Tentang & penafian",
  "help.about": "Gia adalah asisten AI untuk pelaku budidaya perairan, dilengkapi kalkulator teknik. Gia menjawab dari materi rujukan dan pengetahuan umum untuk membantu Anda menelaah sistem, kualitas air, dan peralatan.",
  "legal.englishGoverning": "Syarat dan penafian disediakan dalam bahasa Inggris. Versi bahasa Inggris adalah versi yang berlaku.",
  "feature.notNow": "Nanti saja",
  "feature.seePlans": "Lihat paket",
  "lang.title": "Bahasa",
  "lang.sub": "Menentukan bahasa antarmuka dan bahasa jawaban Gia, apa pun bahasa yang Anda tulis.",
  "lang.auto": "Otomatis (mengikuti peramban dan pertanyaan saya)",
  "pe.timeline.ASAP": "Secepatnya",
  "pe.timeline.1–3 months": "1–3 bulan",
  "pe.timeline.Just researching": "Baru mencari informasi",
  "pe.condition.New": "Baru",
  "pe.condition.Used": "Bekas",
  "pe.condition.Either": "Keduanya boleh",
  "pe.missing.quantity": "berapa unit yang Anda butuhkan",
  "pe.missing.city": "dikirim ke mana",
  "pe.missing.date": "kapan Anda membutuhkannya",
  "pe.nudge": "Pemasok biasanya belum bisa memberi harga tanpa tahu {list}. Anda tetap bisa mengirimnya.",
  "pe.err.name": "Mohon isi nama Anda agar kami tahu harus membalas ke siapa.",
  "pe.err.email": "Mohon isi email Anda agar kami bisa membalas.",
  "pe.err.emailInvalid": "Email itu sepertinya kurang tepat, mohon diperiksa.",
  "pe.err.quantity": "Mohon isi berapa unit yang Anda butuhkan.",
  "pe.err.city": "Mohon isi kota pengiriman.",
  "pe.err.send": "Permintaan Anda tidak terkirim. Silakan coba lagi.",
  "pe.err.network": "Kami tidak dapat terhubung ke server. Periksa koneksi Anda lalu coba lagi.",
  "pe.title": "Bantu saya mendapatkan ini",
  "pe.thanks": "Terima kasih. Kami akan menghubungi Anda di {email}.",
  "pe.done": "Selesai",
  "pe.whatYouNeed": "Yang Anda butuhkan",
  "pe.equipment": "Peralatan",
  "pe.suggestedModels": "Model yang disarankan:",
  "pe.hideDetails": "Sembunyikan detail",
  "pe.editDetails": "Ubah detail",
  "pe.item": "Barang yang Anda butuhkan",
  "pe.specs": "Detail dan ukuran",
  "pe.name": "Nama Anda",
  "pe.email": "Email (agar kami bisa membalas)",
  "pe.when": "Kapan Anda membutuhkannya?",
  "pe.quantity": "Berapa unit yang Anda butuhkan?",
  "pe.quantityPlaceholder": "mis. 2 unit",
  "pe.city": "Kota pengiriman",
  "pe.cityPlaceholder": "Dikirim ke mana?",
  "pe.neededBy": "Dibutuhkan sebelum (opsional)",
  "pe.condition": "Baru atau bekas? (opsional)",
  "pe.budget": "Perkiraan anggaran (opsional)",
  "pe.amount": "Jumlah",
  "pe.budgetAmount": "Jumlah anggaran",
  "pe.budgetCurrency": "Mata uang anggaran",
  "pe.notSure": "Belum tahu",
  "pe.note": "Ada lagi? (opsional)",
  "pe.notePlaceholder": "Informasi lain yang membantu kami menemukan barang yang tepat.",
  "pe.hideFarm": "Sembunyikan data tambak",
  "pe.addFarm": "Tambahkan data tambak (opsional)",
  "pe.farm": "Nama tambak atau perusahaan",
  "pe.country": "Negara",
  "pe.sending": "Mengirim…",
  "pe.send": "Kirim permintaan",
  "pe.reassurance": "Tanpa kewajiban. Orang dari AquaNetica akan membalas lewat email.",
  "toolbar.answerLanguage": "Bahasa: {name}",
  "toolbar.answerLanguageTitle": "Bahasa",
  "project.namePrompt": "Nama proyek?",
  "project.renamePrompt": "Ganti nama proyek:",
  "project.deleteWithChats": "Hapus proyek \"{name}\" dan {count} obrolannya?",
  "project.deleteWithChats_other": "Hapus proyek \"{name}\" dan {count} obrolannya?",
  "project.delete": "Hapus proyek \"{name}\"?",
  "file.proTitle": "Pesan dengan berkas adalah fitur Pro",
  "file.proMessage": "Paket Anda tidak mencakup pesan dengan berkas. Naik ke Pro untuk melampirkan lembar spesifikasi, gambar teknik, dan foto agar bisa dibaca Gia. Pesan dengan berkas adalah setiap pesan yang Anda kirim saat ada berkas terlampir.",
  "file.badType": "Mohon lampirkan gambar (JPG, PNG, GIF, WEBP), PDF, berkas Word, Excel, atau PowerPoint (.docx, .xlsx, .pptx), atau berkas teks atau kode (.txt, .md, .csv, .json, .r, .py).",
  "file.tooLarge": "Berkas terlalu besar. Lampiran harus di bawah 20 MB.",
  "file.unreadable": "Gia tidak dapat membaca berkas itu. Jika berkas dilindungi kata sandi atau berformat lama .doc, .xls, atau .ppt, simpan sebagai .docx, .xlsx, atau .pptx tanpa kata sandi lalu lampirkan lagi.",
  "file.noText": "Berkas itu tidak berisi teks yang dapat dibaca Gia. Jika berupa hasil pindai atau sebagian besar gambar, lampirkan sebagai PDF atau gambar.",
  "file.tooBig": "Berkas itu terlalu besar untuk dibaca Gia sekaligus. Pecah menjadi beberapa berkas yang lebih kecil, atau lampirkan bagian yang Anda perlukan saja.",
  "file.notText": "Berkas itu bukan teks biasa, meskipun namanya menunjukkan begitu. Simpan sebagai teks (UTF-8) lalu lampirkan lagi.",
  "chat.errSomething": "Maaf, ada yang tidak beres: {detail}",
  "chat.errNoBackend": "Maaf, saya tidak bisa menjangkau basis pengetahuan. Periksa apakah backend berjalan di port 3001.",
  "file.attached": "· terlampir di obrolan ini",
  "file.left": "Sisa {count} pesan dengan berkas bulan ini",
  "file.left_other": "Sisa {count} pesan dengan berkas bulan ini",
  "file.detachTitle": "Lepas berkas: berhenti dihitung sebagai pesan dengan berkas",
  "file.detachLabel": "Lepas berkas",
  "file.detach": "Lepas",
  "file.explain": "Setiap pesan yang Anda kirim selagi berkas ini terlampir dihitung sebagai satu pesan dengan berkas. Lepaskan bila Gia tidak perlu lagi merujuknya.",
  "file.reattachHint": "{name}: lampirkan lagi untuk terus bertanya tentangnya",
  "file.reattachTitle": "Lampirkan berkas lagi",
  "file.reattach": "Lampirkan lagi",
  "usage.questions": "Sisa {left} dari {limit} pertanyaan bulan ini",
  "usage.questions_other": "Sisa {left} dari {limit} pertanyaan bulan ini",
  "usage.questionsShort": "Sisa {left}/{limit} pertanyaan",
  "usage.questionsShort_other": "Sisa {left}/{limit} pertanyaan",
  "usage.files": "Sisa {left} dari {limit} pesan dengan berkas",
  "usage.files_other": "Sisa {left} dari {limit} pesan dengan berkas",
  "usage.leftShort": "Sisa {left} pertanyaan",
  "usage.leftShort_other": "Sisa {left} pertanyaan",
  "usage.remaining": "{left} / {limit} pertanyaan tersisa",
  "usage.remaining_other": "{left} / {limit} pertanyaan tersisa",
  "usage.upgrade": "Tingkatkan",
  "wall.daily": "Anda sudah mencapai batas pesan hari ini",
  "wall.feature": "Paket {plan} tidak mencakup ini",
  "wall.featureYour": "Paket Anda tidak mencakup ini",
  "wall.files": "Anda sudah memakai semua {limit} pesan dengan berkas paket {plan} bulan ini",
  "wall.questions": "Anda sudah memakai semua {limit} pertanyaan paket {plan} bulan ini",
  "wall.generic": "Anda sudah mencapai batas paket Anda",
  "wall.region": "Batas pertanyaan tercapai",
  "wall.refresh": "Pertanyaan paket {plan} Anda diperbarui setiap tanggal 1.",
  "wall.refreshNoPlan": "Pertanyaan Anda diperbarui setiap tanggal 1.",
  "wall.stayFree": "Kalkulator tetap gratis dan tanpa batas, dan semua obrolan lama Anda tetap ada di sini untuk dibaca.",
  "wall.upgrade": "Tingkatkan paket di aquanetica.com",
  "sidebar.hide": "Sembunyikan bilah sisi",
  "sidebar.search": "Cari obrolan…",
  "sidebar.newChat": "+ Obrolan baru",
  "sidebar.newProject": "+ Proyek",
  "sidebar.tools": "🛠️ Alat",
  "sidebar.backToGia": "Kembali ke Gia",
  "sidebar.calculator": "Kalkulator",
  "sidebar.empty": "Belum ada obrolan. Tanyakan apa saja ke Gia untuk memulai.",
  "sidebar.profileSet": "Profil sistem sudah diisi",
  "sidebar.newInProject": "Obrolan baru di proyek ini",
  "sidebar.editProfile": "Ubah profil",
  "sidebar.rename": "Ganti nama",
  "sidebar.delete": "Hapus",
  "sidebar.projectEmpty": "Belum ada obrolan",
  "sidebar.noMatches": "Tidak ada hasil untuk \"{q}\"",
  "sidebar.signedIn": "Sudah masuk",
  "sidebar.signOut": "Keluar",
  "sidebar.signingOut": "Sedang keluar…",
  "signout.title": "Keluar",
  "signout.body": "Anda akan keluar dari AquaNetica IQ dan aquanetica.com. Dokumen yang diunggah dan penilaian jawaban selalu dihapus dari perangkat ini. Semua hal lain yang Anda simpan tetap ada di sini saat Anda masuk lagi.",
  "signout.alsoClear": "Hapus juga pekerjaan tersimpan di perangkat ini: percakapan, proyek, dan perhitungan",
  "signout.irreversible": "Penghapusan tambahan ini permanen. Pekerjaan itu hanya tersimpan di peramban ini, jadi tidak ada salinan untuk dipulihkan.",
  "signout.confirm": "Keluar",
  "sidebar.communityTitle": "Kembali ke komunitas AquaNetica (terbuka di tab baru)",
  "sidebar.community": "Kembali ke AquaNetica",
  "sidebar.help": "Bantuan dan penafian",
  "drop.label": "Lepaskan berkas untuk melampirkan",
  "toolbar.showSidebar": "Tampilkan bilah sisi",
  "toolbar.toggleSidebar": "Tampilkan atau sembunyikan bilah sisi",
  "toolbar.newChat": "Obrolan baru",
  "toolbar.inProject": "Di proyek:",
  "toolbar.home": "Kembali ke komunitas AquaNetica",
  "toolbar.homeTitle": "Kembali ke AquaNetica (terbuka di tab baru)",
  "toolbar.calc": "Buka kalkulator",
  "toolbar.theme": "Ganti tema",
  "hero.title": "Ada yang bisa saya bantu?",
  "hero.calibrated": "Gia sudah disesuaikan dengan profil sistem proyek ini.",
  "hero.noProfile": "Belum ada profil sistem. Klik ⚙ pada proyek untuk mengisinya.",
  "hero.subtitle": "Tanyakan apa saja tentang sistem budidaya, kualitas air, atau peralatan.",
  "composer.attachTitle": "Lampirkan gambar atau PDF",
  "composer.attachLabel": "Lampirkan berkas",
  "composer.send": "Kirim",
  "answer.copyTitle": "Salin jawaban",
  "answer.copied": "Tersalin",
  "answer.copy": "Salin",
  "answer.retryTitle": "Tanyakan lagi pertanyaan ini",
  "answer.retryLabel": "Coba jawab lagi",
  "answer.retry": "Coba lagi",
  "answer.good": "Jawaban bagus",
  "answer.bad": "Jawaban kurang tepat",
  "answer.sourcing": "Butuh bantuan mencarikan ini? →",
  "answer.searching": "Mencari di pustaka dokumen…",
  "answer.scrollLatest": "Ke pesan terbaru",
  "sidebar.otherChats": "Lainnya",
  "trial.have": "Punya kode?",
  "trial.title": "Kode uji coba",
  "trial.placeholder": "Masukkan kode uji coba Anda",
  "trial.submit": "Tukarkan",
  "trial.checking": "Memeriksa…",
  "trial.invalid": "Kode itu tidak valid. Periksa lalu coba lagi.",
  "trial.error": "Kami tidak dapat memeriksa kode itu. Silakan coba lagi.",
  "trial.success": "Uji coba Pro dimulai. Anda punya 75 pertanyaan dan 10 pesan dengan berkas per bulan sampai {date}.",
  "trial.active": "Uji coba Pro sampai {date}",
  "sidebar.planTrial": "Uji coba {plan}",
  "sidebar.managePlan": "Kelola paket",
  "trial.ends": "Masa coba berakhir {date}",
  "pe.consent": "Saya setuju rincian permintaan saya dibagikan kepada AquaNetica dan kepada pemasok yang dihubungi atas nama saya, serta menyetujui {terms} dan {privacy}.",
  "pe.consentTerms": "Ketentuan Layanan",
  "pe.consentPrivacy": "Kebijakan Privasi",
};

export default strings;
